import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import Swal from 'sweetalert2';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { DialogTipoRechazo } from '../common/postulacion-rechazar.component';
import { environment } from '../../../environments/environment';

export interface DialogData
{
    archivo: any;
    archivos: any;
    idPostulacion: any;
    beneficiario: string;
    tipoProducto: string;
    etapaEscolar: string;
    diagnostico: string;
    calificacion: string;
    tiposBeca: any;
    cursos: any;
    postulantes: any;
    carga: boolean;
    muestraDiagnostico: boolean;
    deshabilitado: boolean;
    presionaEditar: boolean;
    recarga: boolean;
    email: string;
    nombreCompleto: string;
    mostrarEditar: boolean;
    disponiblePago:any;
    rol: string;
    mostrarAprobarButton:any;
	idUsuario: any;
}

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/postulaciones/postulacion-becas-validar.html',
    styleUrls: ['../../pages/postulaciones/postulaciones.component.css']
})
export class DialogEditPostulacion
{
    constructor( public dialogRef: MatDialogRef<DialogEditPostulacion>,
                 private postulacionesService: PostulacionesService,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, )
    {
        this.data.recarga = false
        this.data.rol = localStorage.getItem('rol')
    }
  
    onRechazarClick()
    {

        let vm = this
        let dataRechazo: any =
        {
            idPostulacion: this.data.idPostulacion, tiposRechazo: [], tipoRechazo: '', email:this.data.email,
            nombreCompleto: this.data.nombreCompleto, nombreProducto: 'BECA'
        }

        this.postulacionesService.motivoRechazo(1).then ( rechazos => { dataRechazo.tiposRechazo = rechazos
      } )
        .catch ( error => {

          console.log(error)
        })

        const dialogRechazo = this.dialog.open(DialogTipoRechazo, { width:'50%', data: dataRechazo })

        dialogRechazo.afterClosed().subscribe( () =>
        {
            vm.data.recarga = true
            vm.dialogRef.close()
        })
    }

    onAprobarClick(): void
    {
        let vm = this
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' }  }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed)
            {

              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
                vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "APROBADA",idUsuarioSesion).then
                (
                    () =>
                    {
                        this.data.recarga=true                      
                        vm.dialogRef.close()
                        Swal.close();
                        vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                    }
                )
                .catch
                (
                    error =>
                    {
                        console.log(error)
                        vm.dialogRef.close()
                        Swal.close();
                        vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                    }
                )
            }
        })
    }

    onEditarClick(): void
    {
        this.data.deshabilitado = false
        this.data.presionaEditar = true
    }

    onCancelarClick(): void { this.dialogRef.close() }
    /*
    onDescargarArchivoClick(): void
    {
      this.data.archivos.forEach( archivo => {

          const byteCharacters = atob(archivo.archivo.split(',')[1])
          const byteNumbers = new Array(byteCharacters.length)

          for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
          }

          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], {type: archivo.extension})

          var fileURL = URL.createObjectURL(blob)
          window.open(fileURL)
      })
    }
    */
    onDescargarArchivosClick(postulacionId: any)
    {
        let vm = this
     
        vm.postulacionesService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`    
                    window.open(fileURL,'_blank')                     
                })  
               
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)
                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )
    }

    onGuardarClick(idCarga: any,idUsuario:any)
    {
        let vm = this
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        let idUsuarioSesion = localStorage.getItem("idUsuario")

        this.postulacionesService.editaPostulacionBeca(this.data.idPostulacion, idCarga, this.data.calificacion, this.data.etapaEscolar,idUsuario, idUsuarioSesion,this.data.diagnostico).then
        (
            () =>
            {
                vm.data.recarga = true
                vm.dialogRef.close()
                Swal.close();
                vm.openAlertDialog('La postulación se ha guardado exitosamente.', 'btn-success')
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)
                vm.dialogRef.close()
                Swal.close();
                vm.openAlertDialog('La postulación no se ha logrado guardar.', 'btn-danger')
            }
        );
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}
